// /store/modules/table.js
import apiClient from '../../plugins/axios';
import router from "../../router";

export default {
  namespaced: true,
  state: () => ({
    table: null,
    loading: false,
    tableDialog: false,
    leads: [],
    rawLeads: [],
    emailAutomations: [],
  }),
  mutations: {
    setTable(state, table) {
      state.table = table;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setTableDialog(state, tableDialog) {
      state.tableDialog = tableDialog;
    },
    resetTable(state) {
      state.table = null;
      state.leads = [];
      state.emailAutomations = [];
      state.rawLeads = [];
    },
    setLeads(state, leads) {
      state.leads = leads;
    },
    setEmailAutomations(state, emailAutomations) {
      state.emailAutomations = emailAutomations;
    },
    setRawLeads(state, rawLeads) {
      state.rawLeads = rawLeads;
    },
  },
  actions: {
    async fetchTableData({ commit, dispatch }, tableId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getTableById?tableId=${tableId}`
        );
        commit("setTable", response.data);
        commit("setTableDialog", true);
        dispatch("fetchLeadsNameAndId");
        dispatch("fetchEmailAutomations");
        dispatch("fetchRawLeads");
      } catch (error) {
        console.error("Failed to fetch table data:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchLeadsNameAndId({ commit, state }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getLeadsNameAndId?tableId=${state.table._id}`
        );
        commit("setLeads", response.data);
      } catch (error) {
        console.error("Failed to fetch leads:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchEmailAutomations({ commit, state }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getEmailAutomationByTableId?tableId=${state.table._id}`
        );
        commit("setEmailAutomations", response.data);
      } catch (error) {
        console.error("Failed to fetch email automations:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchRawLeads({ commit, state }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getRawLeadsByOwnerTable?tableId=${state.table._id}`
        );
        commit("setRawLeads", response.data);
      } catch (error) {
        console.error("Failed to fetch raw leads:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    setTableDialog({ commit }, tableDialog) {
      commit("setTableDialog", tableDialog);
    },
    closeTableDialog({ commit, rootState }) {
      router.replace(rootState.agency.dialogReturnRoute);
      commit("resetTable");
      commit("setTableDialog", false);
    },
    resetTable({ commit }) {
      commit("resetTable");
    }
  },
};
